module.exports = __webpack_public_path__ + "img/icon-qxkpg.a0236988.png";